import type { BoxProps } from '@mui/material'
import { Box } from '@mui/material'
import { useWindowWidth } from './hooks/useWindowWidth'

export const BreakoutSection = (props: BoxProps) => {
  const { children, ...rest } = props
  const windowWidth = useWindowWidth()
  const padding = 4
  const breakoutWidth = `calc( ${windowWidth}px - ${padding}rem)`
  return (
    <Box display="inherit" flexDirection="column" flexGrow={1}>
      <Box
        display="inherit"
        flexDirection="column"
        flexGrow={1}
        width={breakoutWidth}
        position="relative"
        sx={{
          translate: '-50%',
          left: '50%',
        }}
        {...rest}
      >
        {children}
      </Box>
    </Box>
  )
}
